import { computed } from 'vue';
import moment from 'moment-timezone';
import { useNow, toValue } from '@vueuse/core';
import { dateTimeUtils } from '@/utils';

export default function useTimeRemaining(calendarEvent) {
  const { now } = useNow({ interval: 1000, controls: true });
  const { getCalendarEventRange } = dateTimeUtils;

  const timeRemaining = computed(() => {
    const event = toValue(calendarEvent);
    if (!event?.start_date_time) {
      return { duration: '', status: '', label: '' };
    }

    const { start, end } = getCalendarEventRange(event);

    const nowMoment = moment(now.value);
    const timeUntilStart = start.diff(nowMoment);
    const timeUntilEnd = end.diff(nowMoment);

    let duration = '';
    let label = '';
    let status = '';
    if (timeUntilStart > 0) {
      // Event hasn't started yet
      duration = moment.duration(timeUntilStart);
      status = 'upcoming';
      label = duration.humanize(true, { s: 0, ss: 0 });
    } else if (timeUntilStart <= 0 && timeUntilEnd > 0) {
      // Event is ongoing
      duration = moment.duration(timeUntilEnd);
      status = 'occurring';
      label = moment.utc(duration.asMilliseconds()).format('mm:ss');
    }
    return {
      duration,
      status,
      label,
      timeUntilStart,
      timeUntilEnd,
    };
  });

  return {
    timeRemaining,
  };
}
